// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2T8oo","signatureButtonsRight":"ModalSign_signatureButtonsRight__1sj6T"};